import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { COLLECTIONS } from "../constants";
import { Observable } from "rxjs";
import { ILessonActivities } from "../models/activities.model";

@Injectable({
	providedIn: 'root',
})
export class FirestoreService {

	constructor(
		public readonly db : AngularFirestore,
	) {}

	getLessonActivitiesByVersion(lessonId: string, version: number): Observable<ILessonActivities[]> {
		return this.db.collection<ILessonActivities>(COLLECTIONS.LessonActivities, ref =>
			ref.where('lessonId', '==', lessonId)
			.where('version', '==', version)
		).valueChanges();
	}
}
